import { Bold as m } from "../node_modules/@tiptap/extension-bold/dist/index.mjs";
import { Document as a } from "../node_modules/@tiptap/extension-document/dist/index.mjs";
import { Italic as l } from "../node_modules/@tiptap/extension-italic/dist/index.mjs";
import { Strike as x } from "../node_modules/@tiptap/extension-strike/dist/index.mjs";
import { Text as f } from "../node_modules/@tiptap/extension-text/dist/index.mjs";
import { Underline as s } from "../node_modules/@tiptap/extension-underline/dist/index.mjs";
import { CharacterCount as d, Dropcursor as c, UndoRedo as p } from "../node_modules/@tiptap/extensions/dist/index.mjs";
import { EditorExtensionEnum as r } from "../enums/editor-extensions-enum.mjs";
import { FontFamily as u } from "../extensions/font-family-extension/index.mjs";
import { createFontSizeExtension as E } from "../extensions/font-size-extension/index.mjs";
import { SimpleHardBreakExtension as g, HardBreakExtension as k } from "../extensions/hard-break-extension/index.mjs";
import { HeadingExtension as L } from "../extensions/heading-extension/index.mjs";
import { LineHeightExtension as S } from "../extensions/line-height-extension/index.mjs";
import { createSimpleLinkExtension as B, createLinkExtension as C } from "../extensions/link-extension/index.mjs";
import { ParagraphExtension as I } from "../extensions/paragraph-extension/index.mjs";
import { TextAlignExtension as T } from "../extensions/text-align-extension/index.mjs";
import { TextColor as H } from "../extensions/text-color-extension/index.mjs";
import { TextStyle as h } from "../extensions/text-style-extension/index.mjs";
import { TextBackgroundColor as F } from "../extensions/text-background-color-extension/index.mjs";
import { BlockImage as y } from "../extensions/image-extension/block-image.mjs";
import { InlineImage as A } from "../extensions/image-extension/inline-image.mjs";
import { Indent as D } from "../extensions/indent-extension/indent.mjs";
import { ListItemExtension as z, OrderedListExtension as O, BulletListExtension as U } from "../extensions/list-extension/list-extension.mjs";
const ir = (i, e) => {
  const t = {
    [r.Document]: a,
    [r.Paragraph]: I,
    [r.Text]: f,
    [r.TextStyle]: h,
    [r.FontFamily]: u,
    [r.Heading]: L,
    [r.Bold]: m,
    [r.Italic]: l,
    [r.Strike]: x,
    [r.Underline]: s,
    [r.BulletList]: U,
    [r.OrderedList]: O,
    [r.ListItem]: z,
    [r.TextAlign]: T,
    [r.Link]: C(e == null ? void 0 : e[r.Link]),
    [r.SimpleLink]: B(
      e == null ? void 0 : e[r.Link]
    ),
    [r.History]: p,
    [r.TextColor]: H,
    [r.TextBackgroundColor]: F,
    [r.FontSize]: E(
      e == null ? void 0 : e[r.FontSize]
    ),
    [r.LineHeight]: S,
    [r.Indent]: D,
    [r.HardBreak]: k,
    [r.SimpleHardBreak]: g,
    [r.Substitution]: null,
    [r.SpecialCharacters]: null,
    [r.Image]: [y, A],
    [r.DropCursor]: c,
    [r.CharacterCount]: d
  };
  return i.flatMap((o) => {
    const n = t[o];
    return Array.isArray(n) ? n : [n];
  }).filter((o) => o !== null);
}, or = (i) => Object.values(r).reduce(
  (e, t) => ({
    ...e,
    [`has${r[t]}`]: i.includes(t)
  }),
  {}
);
export {
  or as getExistingExtensions,
  ir as getExtensions
};
